import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, TextField, Typography  } from '@mui/material';
import { ROLES } from '../../services/user.service';
import { userService } from '../../services/user.service'; // Asegúrate de importar userService si no lo has hecho

const NoteModal = ({ isOpen, onClose, initialText = '', onSave, field }) => {
    const [text, setText] = useState(initialText);
    const [user, setUser] = useState(userService.getLoggedinUser().data.data); // Usuario logueado en la interfaz

    // Este hook asegura que el texto en el modal esté sincronizado con initialText
    useEffect(() => {
        setText(initialText);
    }, [initialText]);

    const handleSave = (ev) => {
        onSave(ev, field, text);
        onClose();
    };

    // Verifica si el botón de guardar y la edición deben estar habilitados o deshabilitados
    const isEditable = (user.rol === ROLES.ADMIN || (field === "avances" && user.rol !== ROLES.AUDITOR));


    // Mapea el campo a un título adecuado
    const getTitle = (field) => {
        switch (field) {
            case 'avances':
                return 'Descripción de Avances';
            case 'descripcion':
                return 'Descripción de Actividad';
            default:
                return 'Editar Nota';
        }
    };

    return (
        <Modal open={isOpen} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 700,
                    bgcolor: 'background.paper',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                 <Typography 
                    variant="h6" 
                    sx={{ mb: 2, textAlign: 'left', fontWeight: 'bold' }}
                >
                    {getTitle(field)}
                </Typography>

                <TextField
                    fullWidth
                    multiline
                    rows={10}
                    variant="outlined"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    InputProps={{
                        readOnly: !isEditable, // Hace el campo de solo lectura si no es editable
                    }}
                />
                <Button 
                    variant="contained" 
                    onClick={handleSave} 
                    sx={{ mt: 2 }}
                    disabled={!isEditable} // Deshabilita el botón si no es editable
                >
                    Guardar
                </Button>
            </Box>
        </Modal>
    );
};

export default NoteModal;
